export default __webpack_public_path__ + "static/media/021-rabbit.e8238ee3.svg";